import { createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b0472800")

_pushScopeId("data-v-b0472800")
const _hoisted_1 = { class: "ensure-service-explain" }
const _hoisted_2 = /*#__PURE__*/_createVNode("i", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createTextVNode("检测标准解读 ")
const _hoisted_4 = { class: "demo-tab-width-title" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "demo-tab-width-line" }, null, -1)
const _hoisted_6 = {
  key: 0,
  class: "ensure-section"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode()
const _hoisted_8 = { class: "ensure-img" }
const _hoisted_9 = { class: "ensure-img-title" }
const _hoisted_10 = {
  key: 0,
  class: "ensure-img-tag"
}
const _hoisted_11 = {
  key: 1,
  class: "ensure-section"
}
const _hoisted_12 = { class: "ensure-text" }
const _hoisted_13 = /*#__PURE__*/_createTextVNode()
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_van_tab = _resolveComponent("van-tab")
  const _component_van_tabs = _resolveComponent("van-tabs")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "ensure-service-explain-header",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
    }, [
      _hoisted_2,
      _hoisted_3
    ]),
    _createVNode(_component_van_tabs, {
      modelValue: _ctx.state.activeName,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.state.activeName = $event)),
      scrollspy: "",
      sticky: "",
      class: "van-tabs__wrap--scrollable"
    }, {
      default: _withId(() => [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.state.checkItemsExplain, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            key: index,
            name: item.title
          }, {
            title: _withId(() => [
              _createVNode("span", null, [
                _createVNode("span", _hoisted_4, _toDisplayString(item.title), 1),
                _hoisted_5
              ])
            ]),
            default: _withId(() => [
              (item.title === '事故检测')
                ? (_openBlock(), _createBlock("div", _hoisted_6, [
                    _createVNode("div", {
                      class: "ensure-title",
                      id: item.title
                    }, _toDisplayString(item.title), 9, ["id"]),
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.definitionList, (items) => {
                      return _withDirectives((_openBlock(), _createBlock("div", {
                        class: "ensure-text",
                        key: items.definitionTitle
                      }, [
                        _createVNode("p", null, [
                          _createVNode("span", null, _toDisplayString(items.definitionTitle), 1),
                          _hoisted_7,
                          _createVNode("i", {
                            innerHTML: items.definition
                          }, null, 8, ["innerHTML"])
                        ]),
                        _createVNode("p", null, [
                          _createVNode("span", null, _toDisplayString(items.standardTitle), 1),
                          _createTextVNode(" " + _toDisplayString(items.standard), 1)
                        ])
                      ], 512)), [
                        [_vShow, items.show]
                      ])
                    }), 128)),
                    _createVNode("div", _hoisted_8, [
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(item.standardImg, (itemI) => {
                        return (_openBlock(), _createBlock("div", {
                          class: "ensure-img-item",
                          key: itemI.imgTitle
                        }, [
                          _createVNode("div", _hoisted_9, _toDisplayString(itemI.imgTitle), 1),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(itemI.imgList, (itemImg, index) => {
                            return (_openBlock(), _createBlock("div", {
                              class: "ensure-img-box",
                              key: index
                            }, [
                              _createVNode("img", {
                                src: itemImg.imgSrc
                              }, null, 8, ["src"]),
                              (itemImg.imgType)
                                ? (_openBlock(), _createBlock("span", _hoisted_10, _toDisplayString(itemImg.imgType), 1))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ]))
                      }), 128))
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_11, [
                    _createVNode("div", {
                      class: "ensure-title",
                      id: item.title
                    }, _toDisplayString(item.title), 9, ["id"]),
                    _createVNode("div", _hoisted_12, [
                      _createVNode("p", null, [
                        _createVNode("span", null, _toDisplayString(item.definitionTitle), 1),
                        _hoisted_13,
                        _createVNode("i", {
                          innerHTML: item.definition
                        }, null, 8, ["innerHTML"])
                      ]),
                      _createVNode("p", null, [
                        _createVNode("span", null, _toDisplayString(item.standardTitle), 1),
                        _createTextVNode(" " + _toDisplayString(_ctx.state.reportMsg.RpRC() && item.standardRC  ? item.standardRC  : item.standard), 1)
                      ])
                    ])
                  ]))
            ]),
            _: 2
          }, 1032, ["name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})